<template>
  <div class="catalog-filter-container" :class="{ 'catalog-filter-container--no-drawer': responsive.lg || noDrawer }">
    <div
      v-if="responsive.lg || noDrawer"
      class="catalog-filter catalog-filter--open"
      :class="{ 'catalog-filter--no-margin-top': noDrawer }"
    >
      <catalog-filter
        v-bind="{search, items, selectedFacets, ...$attrs}"
        :selected-main-facet-value-id="selectedMainFacetValueId"
        :main-facet-with-values="mainFacetWithValues"
        @toggle-select="onToggleSelect($event)"
        @main-facet-value-selected="onMainFacetValueSelected($event)"
        @search="onSearch"
      />
    </div>
    <base-drawer
      v-else
      title="Filter"
      :drawer-open="drawerOpen"
      @close="toggleFilterDrawer"
    >
      <div class="catalog-filter-container__drawer-content">
        <div class="catalog-filter" :class="{ 'catalog-filter--open': drawerOpen }">
          <catalog-filter
            v-bind="{search, items, selectedFacets, ...$attrs}"
            :selected-main-facet-value-id="selectedMainFacetValueId"
            :main-facet-with-values="mainFacetWithValues"
            @toggle-select="onToggleSelect($event)"
            @main-facet-value-selected="onMainFacetValueSelected($event)"
            @search="onSearch"
          />
        </div>
        <div>
          <base-button
            block
            inverse
            @click="toggleFilterDrawer"
          >
            Filter
          </base-button>
        </div>
      </div>
    </base-drawer>
  </div>
</template>

<script>
import _ from 'lodash';
import responsive from '@/components/mixins/responsive';
import { EventBus } from '@/event-bus';
import BaseDrawer from '../../Base/BaseDrawer';
import CatalogFilter from './CatalogFilter';
import BaseButton from '../../Base/BaseButton';

export default {
  name: 'CatalogFilterContainer',
  components: {
    BaseButton,
    BaseDrawer,
    CatalogFilter,
  },
  mixins: [responsive],
  inheritAttrs: false,
  props: {
    noDrawer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    search: {
      get() {
        return this.$store.state.catalog.search;
      },
      set(value) {
        this.$store.commit('catalog/setSearch', value);
        this.$router.push({ query: { q: value } });
      },
    },
    selectedFacets() {
      return this.$store.state.catalog.selectedFacets;
    },
    selectedFacetsName() {
      return this.$store.state.catalog.selectedFacetsName;
    },
    mainFacetWithValues() {
      return this.$store.getters['catalog/mainFacetWithValues'];
    },
    items() {
      return this.$store.state.catalog.facets;
    },
    drawerOpen() {
      return this.$store.getters['catalog/filterDrawerIsOpen'];
    },
    selectedMainFacetValueId() {
      return this.$store.getters['catalog/selectedMainFacetValueId'];
    },
  },
  created() {
    EventBus.$on('searchFilterProduct', (val) => {
      this.search = val;
    }, 200);
    if (this.$store.state.account
        && this.$store.state.account.user.profile.institution.is_matchesfashion) {
      this.$store.dispatch('catalog/fetchFacets', 'in-mf-taxonomy');
    } else {
      this.$store.dispatch('catalog/fetchFacets', {});
    }
  },
  mounted() {
    const queryParams = new URLSearchParams(window.location.search);
    const query = queryParams.get('q');
    if (query) {
      this.$store.commit('catalog/setSearch', query);
    }
  },
  methods: {
    async onToggleSelect(filter) {
      await this.$store.dispatch('catalog/toggleSelectedFilter', filter);

      const obj = {};
      obj[this.mainFacetWithValues.name] = this.selectedMainFacetValueId;

      if (this.selectedFacets.length > 0) {
        for (let item = 0; item < this.selectedFacets.length; item += 1) {
          const facetValueId = this.selectedFacets[item];
          const facetName = this.selectedFacetsName[item].facet_name;
          if (!(facetName in obj)) {
            obj[facetName] = [facetValueId];
          } else {
            obj[facetName].push(facetValueId);
          }
        }
        Object.entries(obj).forEach(([k, v]) => {
          try {
            obj[k] = v.join(',');
          } catch (e) {
            console.log(e);
          }
        });
        this.$store.dispatch('catalog/fetchFacets', { specialHandling: false, additionalParams: obj });
      } else {
        this.$store.dispatch('catalog/fetchFacets', { additionalParams: obj });
      }
    },
    async onMainFacetValueSelected(mainFacetValueId) {
      await this.$store.dispatch('catalog/clearFilters');
      await this.$store.dispatch('catalog/setSelectedMainFacetValueId', mainFacetValueId);

      const obj = {};
      obj[this.mainFacetWithValues.name] = this.selectedMainFacetValueId;
      this.$store.dispatch('catalog/fetchFacets', { additionalParams: obj });
    },
    onSearch: _.debounce(function onSearch(evt) {
      this.search = evt;
    }, 200),

    toggleFilterDrawer() {
      this.$store.dispatch('catalog/toggleFilterDrawer');
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-filter-container {
  position: absolute;
  z-index: 1000;

  &--no-drawer {
    display: block;
    position: relative;
  }
  &__drawer-content {
    display: flex;
    transition: 0.3s;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 50px;
  }
  overflow:auto;
}
.catalog-filter {
  z-index: 1000;

  @media (min-width: map-get($breakpoints,'lg')) {
    margin-top: 10px;
    display: block;
  }
  &--no-margin-top {
    margin-top: 0;
  }
  &--open {
    display: block;
    flex-grow:1;
  }
}
</style>
